export const PENDING = "Pending";
export const SENT = "Sent";
export const ACKNOWLEDGED = "Acknowledged";
export const FAILED = "Failed";
export const CANCELED = "Canceled";
